import { FC } from "react"
import CheckIcon from '@mui/icons-material/Check';
import styles from './WageButton.module.css'
import HelpIcon from '@mui/icons-material/Help';
import clsx from 'clsx'
import { Tooltip } from "@material-ui/core";

type Props = {
  tier: 'low' | 'standard' | 'high'
  wage: number
  onClick: (tier: 'low' | 'standard' | 'high') => void
  isChecked?: boolean
  disabled?: boolean
}

const WageButton: FC<Props> = ({ tier, wage, onClick, isChecked = false, disabled}) => {
  const tooltipText = {
    low: 'Weekdays, low season, planned in advance.',
    standard: 'Standard wage for position',
    high: 'Last minute, or if you need someone highly skilled',
  }

  return (
    <div 
      className={clsx(styles.wageBtn, isChecked && styles.isChecked)}
      style={{ backgroundColor: isChecked ? '#2FCC71' : disabled ? 'lightgray' : 'white' }}
      onClick={disabled ? undefined : () => onClick(tier)}
    >
      {isChecked && <CheckIcon className={styles.checkIcon}/>}
      <span className={styles.label}>{tier}:</span>
      <span className={styles.wage}>{wage} NOK</span>
      <Tooltip title={tooltipText[tier]} placement="top">
        <HelpIcon className={styles.tooltipIcon}/>
      </Tooltip>
    </div>
  )
}

export default WageButton